import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import { cn } from '@/lib/utils';

const SubpageNavigation: React.FC = () => {
  const location = useLocation();
  
  const navItems = [
    { path: '/', label: 'Overview', exact: true },
    { path: '/pomodoro', label: 'Pomodoro' },
    { path: '/kanban', label: 'Kanban' },
    { path: '/eisenhower', label: 'Matrix' },
    { path: '/tasks', label: 'Tasks' }
  ];

  const isActive = (path: string) => {
    return location.pathname === path;
  };

  return (
    <nav className="mb-8" role="tablist" aria-label="Content navigation">
      <div className="bg-secondary rounded-xl p-1 flex w-full gap-1">
        {navItems.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            role="tab"
            aria-selected={isActive(item.path)}
            className={cn(
              "flex-1 flex-shrink-0 px-3 py-2 text-sm rounded-lg font-medium text-center",
              "leading-5 flex items-center justify-center box-border",
              "hover:bg-background/50",
              "focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 focus:ring-offset-secondary",
              "transition-all duration-200 ease-in-out",
              isActive(item.path)
                ? 'bg-background text-foreground shadow-sm'
                : 'text-muted-foreground hover:text-foreground'
            )}
          >
            {item.label}
          </Link>
        ))}
      </div>
    </nav>
  );
};

export default SubpageNavigation;